<template>
  <el-menu :default-active="defaultActive" class="client_menu" mode="horizontal">
    <el-menu-item :index="item.url" v-for="(item, index) in items" :key="index">
      <router-link :to="item.url">{{item.title}}</router-link>
    </el-menu-item>
  </el-menu>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          title: '首页',
          url: '/home'
        },{
          title: '产品文档',
          url: '/document'
        },{
          title: '产品动态',
          url: '/dynamics'
        },
      ],
      activeName: '首页',
      defaultActive: '/home',
    };
  },

  mounted() {},
  //监听路由改变
  watch: {
    '$route':{
      handler(to, from){
        if(to.path.indexOf('/home') > -1){
          this.defaultActive = '/home';
        }else if(to.path.indexOf('/document') > -1){
          this.defaultActive = '/document';
        }else if(to.path.indexOf('/dynamics') > -1){
          this.defaultActive = '/dynamics';
        }else{
          this.defaultActive = '/home';
        }
      },
      immediate: true
    }
  },
  methods: {
    
  },
};
</script>

<style lang="sass" rel="stylesheet/scss" scoped>
.client_menu {
  background-color: #fff;
  margin-left: 50px;
  li{
    color: #333;
    a{
      text-decoration: none;
      font-size: 16px;
      height: 100%;
      display: inline-block;
    }
  }
}
</style>


// WEBPACK FOOTER //
// Tabs.vue?7b24db71